// extracted by mini-css-extract-plugin
export var externalLink = "_do-0";
export var internalLinkLabel = "_do-1";